import usePrivateAxios from "@/common/api/usePrivateAxios";
import { useQuery } from "@tanstack/react-query";

export type Product = {
  id: string;
  display_name: string;
};

interface UseMissionProductsProps {
  filters?: {
    search?: string;
    establishmentBranchId?: string;
  };
};

export const useMissionProducts = ({ filters: { search, establishmentBranchId } = {} }: UseMissionProductsProps) => {
  const privateAxios = usePrivateAxios();

  return useQuery<Product[]>({
    queryKey: ['missionProducts', search, establishmentBranchId],
    queryFn: async () => {
      const response = await privateAxios.get("/tmais/products", {
        params: {
          search,
          'q[establishment_company_branch_id_eq]': establishmentBranchId,
        },
      });
      return response.data.data;
    }
  });
};
